import axios from 'axios'

export const instance = axios.create({
  baseURL: site_vars.rest_url,
  timeout: 1000
});